module.exports = __webpack_public_path__ + "img/chevron.ccbc52d0.svg";